<div id="reference-tree-view" #referenceTree>
  <div class="header">
    <div class="label property-name">
      {{ 'WHERE_USED' | translate }}:
      <span class="highlighted-text label item-label" [pTooltip]="itemName" tooltipPosition="top">{{ itemName }}</span>
      <span class="item-type">{{ itemType }}</span>
    </div>
    <div>
      <span
        (click)="closePopup('close')"
        (keyup.enter)="closePopup('close')"
        tabindex="0"
        aria-label="Close popup"
        class="outline-disable"
      >
        <i class="pi pi-times-circle close-icon" style="font-size: 1.5rem"></i>
      </span>
    </div>
  </div>
  <div class="body">
    <div class="info-section" [ngClass]="{ 'pb-2': cols.length === 2 }">
      <p-tabs
        *ngIf="config?.data?.validateTabs && cols.length === 2"
        [value]="activeTab"
        (valueChange)="onTabChange($event)"
      >
        <p-tablist>
          <p-tab value="MISSING">
            <div class="tab-label-container" [ngClass]="{ active: activeTab === 'MISSING' }">
              <div class="header-btn">1</div>
              <p>{{ 'MISSING_REFERENCES' | translate }} ({{ rawMissing?.length || 0 }})</p>
            </div>
          </p-tab>
          <p-tab value="STALE">
            <div class="tab-label-container" [ngClass]="{ active: activeTab === 'STALE' }">
              <div class="header-btn">2</div>
              <p>{{ 'STALE_REFERENCES' | translate }} ({{ rawStale?.length || 0 }})</p>
            </div>
          </p-tab>
        </p-tablist>
      </p-tabs>
      <div class="reference-info" *ngIf="cols.length !== 2 || itemAction === 'WHERE_USED'">
        @if (itemAction === 'WHERE_USED') {
          <span> {{ 'REFERENCE_TREE_INFO_WHERE_USED' | translate }}</span>
        } @else {
          <span class="reference-info-inline" style="display: flex; align-items: flex-start; gap: 8px">
            <span>
              {{
                'REFERENCE_TREE_INFO'
                  | translate
                    : { action: itemAction == 'DELETE' ? 'delete' : itemAction === 'RENAME' ? 'rename' : 'update' }
              }}
            </span>
            <span *ngIf="warningPropsCount > 0" class="reference-warning-top d-flex align-items-start">
              <span class="warning-icon pr-1"><i class="pi pi-exclamation-triangle"></i></span>
              <span>{{ warningPropsCount }} warning{{ warningPropsCount > 1 ? 's' : '' }} found</span>
            </span>
          </span>
        }
      </div>
      <div class="warning-container" #warningContainer>
        <span
          class="warning-pill"
          *ngIf="warnings.dataWarning && showDataWarning"
          (mouseenter)="opdata.show($event)"
          (mouseleave)="opdata.hide($event)"
        >
          <span class="warning-icon"> </span>
          <span> Data Warning</span>
        </span>
        <span
          class="warning-pill"
          *ngIf="warnings.codeWarning && showCodeWarning"
          (mouseenter)="opcustom.show($event)"
          (mouseleave)="opcustom.hide($event)"
        >
          <span class="warning-icon"> </span>
          <span> Code Warning </span>
        </span>
      </div>

      <p-popover #opdata styleClass="reference-custom-warning">
        <ng-template #content>
          <span class="warning-content">
            {{ warnings.dataWarning }}
          </span>
        </ng-template>
      </p-popover>

      <p-popover #opcustom styleClass="reference-custom-warning">
        <ng-template #content>
          <span class="warning-content">
            {{ warnings.codeWarning }}
          </span>
        </ng-template>
      </p-popover>
    </div>

    <p-treetable
      [value]="files"
      [columns]="cols"
      [lazy]="true"
      (onLazyLoad)="loadNodes()"
      [loading]="loading"
      (onNodeExpand)="onNodeExpand($event, 'true')"
      (onNodeCollapse)="onNodeCollapse($event)"
      [scrollable]="true"
      [scrollHeight]="'60vh'"
      [autoLayout]="true"
      [showLoader]="false"
      [ngClass]="{ 'expanded-view': pageExpanded }"
      rowGroupMode="rowspan"
      groupRowsBy="warning"
    >
      <ng-template #header let-columns>
        <tr>
          <th
            *ngFor="let col of columns"
            class="{{ col.field }} "
            [ngClass]="{
              'd-none': col.field === 'onDeleteConfirmation' && itemAction === 'NOTAPPLICABLE',
              'w-70': columns.length === 2 && col.field === 'usedIn'
            }"
          >
            {{ col.header | translate }}
          </th>
        </tr>
      </ng-template>
      <ng-template #body let-rowNode let-rowData="rowData" let-columns="columns" let-rowIndex="rowIndex">
        <tr>
          <td
            *ngFor="let col of columns; let i = index"
            class="{{ col.field }}"
            [ngClass]="{
              'd-none': col.field === 'onDeleteConfirmation' && itemAction === 'NOTAPPLICABLE',
              'w-70': columns.length === 2 && col.field === 'usedIn',
              hasReference: !rowNode.node?.expand?.includes(col.field)
            }"
          >
            <p-treetable-toggler
              [rowNode]="rowNode"
              id="treeTableToggler-{{ col.fieldId }}-{{ rowNode.level }}"
              class="custom-expand tree-toggle-level-{{ rowNode.level }} column-{{ col.fieldId }}"
              *ngIf="col.field === 'componentType'"
            />

            <span *ngFor="let row of generateArray(rowNode); let levelIndex = index">
              <span
                class="ver-line ver-line-{{ levelIndex }}"
                [ngClass]="{
                  lastNode: rowNode?.node.levelLastNode && levelIndex + 1 === rowNode.level,
                  firstNode: rowNode.node.hasChildElements && levelIndex + 1 !== rowNode.level
                }"
                *ngIf="
                  col.field === 'componentType' && drawLines(rowNode, levelIndex, col, generateArray(rowNode).length)
                "
              >
              </span>
            </span>

            <!-- Horizontal Lines -->

            <span
              class="hr-line hr-line-{{ rowNode.level - 1 }}"
              *ngIf="rowNode.node?.hasParentNode?.includes(col.field) && rowNode.parent"
            ></span>

            <!-- Arrow for UsedIn column -->
            <span *ngIf="col.field === 'componentType'">
              {{ rowData[col.fieldId] | translate }}
            </span>

            <div *ngIf="col.field === 'usedIn'" class="usedIn-column" [ngClass]="{ 'd-flex': itemAction !== 'WHERE_USED' && itemType === 'Query string'}">
              <span class="usd-con" *ngFor="let d of rowData['usedIn']; let uindex = index">
                <span class="item-label" title="{{ d.key }}">{{ d.key | translate }}</span>
                <span
                  class="item-type"
                  *ngIf="d.type"
                  [ngStyle]="{ 'margin-right': itemType === 'Query string' ? '0' : '1rem' }"
                  >{{ d.type | translate }}</span
                >
                <span class="right-arrow" *ngIf="rowData['usedIn'].length !== uindex + 1"></span>
              </span>
              <div *ngIf="itemType === 'Query string' && itemAction === 'DELETE'" class="edit-button-container">
                <p-button
                  icon="pi pi-pencil"
                  styleClass="p-button-sm p-button-rounded p-button-outlined"
                  (onClick)="editQuery(rowNode.node)"
                  pTooltip="Edit Query"
                  tooltipPosition="top"
                  tooltipStyleClass="action-tooltip"
                ></p-button>
              </div>
            </div>

            <span
              *ngIf="col.field === 'type'"
              [ngClass]="rowData[col.fieldId] === 'Auto' ? 'type-auto' : 'type-manual'"
            >
              {{ rowData[col.fieldId] }}
            </span>

            <div *ngIf="col.field === 'onDeleteConfirmation'">
              <div
                *ngIf="
                  warningPropertyNames.includes(rowData?.propertyName) || rowData?.referredModelType === 'QUERY_BUILDER'
                "
              >
                <div>
                  <span>
                    <span class="reference-warning-color"><i class="pi pi-exclamation-triangle"></i>&nbsp;</span>
                    <span class="font-weight-bold reference-warning-color">{{ 'WARNING' | translate }}:&nbsp;</span>
                    {{ rowData[col.fieldId] | translate }}
                  </span>
                </div>
              </div>
            </div>
          </td>
        </tr>
        <div *ngIf="loading">
          <p-progress-spinner></p-progress-spinner>
        </div>
      </ng-template>

      <ng-template pTemplate="emptymessage" let-columns>
        <tr class="no-records">
          <td colspan="6" class="text-center">
            {{ 'NO_RECORDS_FOUND' | translate }}
          </td>
        </tr>
      </ng-template>
    </p-treetable>
  </div>
  <div class="footer">
    <div class="text-right">
      <p-button
        pRipple
        label="{{ 'CLOSE' | translate }}"
        class="reset"
        [ngClass]="isBetaAccessPrivilegeConsumable ? 'button-filled' : ''"
        (onClick)="closePopup('close', $event)"
        *ngIf="(config?.data?.validateTabs && cols.length === 2) || itemAction === 'WHERE_USED' || config?.data?.hideConfirm; else confirmTpl"
      />
      <ng-template #confirmTpl>
        <p-button
          pRipple
          label="{{ 'CANCEL' | translate }}"
          class="reset"
          [ngClass]="isBetaAccessPrivilegeConsumable ? 'button-outlined' : ''"
          (onClick)="closePopup('close', $event)"
        />
        <p-button
          pRipple
          label="{{ 'CONFIRM' | translate }}"
          class="confirm"
          [ngClass]="isBetaAccessPrivilegeConsumable ? 'button-filled' : ''"
          (onClick)="closePopup('confirm', $event)"
        />
      </ng-template>
    </div>
  </div>
</div>

<vb-editor-with-autocomplete
  (deletedValue)="updateLatestQueryString($event)"
  [formData]="currentDatamodel"
  [usedIn]="'referenceQueryEdit'"
  (notifySave)="saveAndRefresh($event)"
></vb-editor-with-autocomplete>
